import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=aa1473e8&scoped=true&"
import script from "./MyProfile.vue?vue&type=script&lang=ts&"
export * from "./MyProfile.vue?vue&type=script&lang=ts&"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=aa1473e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1473e8",
  null
  
)

export default component.exports